import React from "react";
const WIDTH = 90;
const DEPTH = 40;
const HEIGHT = 30;

export default {
  name: "round-dining-table-for-4",
  prototype: "items",

  info: {
    tag: ["furnishings", "metal"],
    title: "round dining table for 4",
    description: "bathroom-sink",
    image: require("./round-dining-table-for-4.svg"),
    svgIcon: require("./round-dining-table-for-4.svg"),
  },
  properties: {
    scaleX: {
      label: "Width",
      type: "slider",
      min: 10,
      max: 500,
      defaultValue: 100,
    },
    scaleY: {
      label: "Depth",
      type: "slider",
      min: 10,
      max: 500,
      defaultValue: 100,
    },
  },

  render2D: function (element, layer, scene) {
    let angle = element.rotation + 90;

    return {
      element: (
        <g transform={`translate(-47, 55) scale(1, -1)`}>
          <defs>
            <style>{`.cls-1{fill:#fff;}`}</style>
          </defs>
          <g id={`${element.type}-${element.id}`} data-name="corner shower">
            <path
              d="M5.64,36.43c1.24-.18,2.44-.34,3.63-.56a1,1,0,0,0,.52-.54c1.11-2.5,2-5.13,3.33-7.51a40.23,40.23,0,0,1,23.19-19c.63-.21.89-.47.83-1.15A6.1,6.1,0,0,1,37.31,6a15,15,0,0,1,.51-1.62l-.63-.06a2.06,2.06,0,0,1-1.87-2.11,2,2,0,0,1,2-2c3.81,0,7.62,0,11.43,0,4.08,0,8.15,0,12.23,0a1.9,1.9,0,0,1,2,1.65,2,2,0,0,1-1.36,2.34,9.4,9.4,0,0,1-1.12.18,8.49,8.49,0,0,1,.77,3.95c0,.19.34.45.58.56,2.45,1.12,5,2,7.34,3.36A40.17,40.17,0,0,1,87.65,34.84a1.28,1.28,0,0,0,1.43,1.06,29.79,29.79,0,0,1,3.61.49,6,6,0,0,1,.17-.9,2,2,0,0,1,2.25-1.38A1.93,1.93,0,0,1,96.81,36c0,1.76,0,3.52,0,5.28q0,9.23,0,18.46a2,2,0,0,1-1.52,1.94,2,2,0,0,1-2.24-.94,7.93,7.93,0,0,1-.46-1.49,9.8,9.8,0,0,1-4.33.74c-.18,0-.45.38-.53.63a41.1,41.1,0,0,1-25.63,26,1.1,1.1,0,0,0-.91,1.19c0,1.23-.29,2.45-.46,3.73l.34,0a2.06,2.06,0,0,1,2,2.1,2,2,0,0,1-2.05,2H39.12c-.58,0-1.16,0-1.73,0a1.94,1.94,0,0,1-2-2,2,2,0,0,1,1.88-2.07l.64-.07a8.56,8.56,0,0,1-.78-4c0-.19-.33-.48-.56-.56A41.2,41.2,0,0,1,10,60.8c-.19-.56-.4-.83-1-.79a6.56,6.56,0,0,1-1.65-.17c-.53-.12-1-.32-1.61-.5,0,.22,0,.43-.07.63a2.05,2.05,0,0,1-2.13,1.84,2,2,0,0,1-1.93-2c0-4,0-7.91,0-11.87s0-7.91,0-11.86a2,2,0,0,1,2.16-2A2.06,2.06,0,0,1,5.6,35.9,5,5,0,0,1,5.64,36.43ZM48.86,88.21A40.37,40.37,0,1,0,8.5,47.92,40.37,40.37,0,0,0,48.86,88.21ZM88.27,36.78a41.47,41.47,0,0,1,0,22.25,6.56,6.56,0,0,0,4-.66,1.15,1.15,0,0,0,.5-.81q0-9.63,0-19.25a1.18,1.18,0,0,0-.5-.83A6.79,6.79,0,0,0,88.27,36.78Zm-28,50.43a41.57,41.57,0,0,1-22.24.21,7,7,0,0,0,.69,3.63.84.84,0,0,0,.84.51l19.23,0a1.07,1.07,0,0,0,.77-.45A6.4,6.4,0,0,0,60.3,87.21ZM38,8.26A41.18,41.18,0,0,1,49.15,6.82,42.24,42.24,0,0,1,60.31,8.44a6.64,6.64,0,0,0-.74-3.61,1.12,1.12,0,0,0-.77-.47q-9.64,0-19.31,0a1.07,1.07,0,0,0-.75.48A5.74,5.74,0,0,0,38,8.26ZM9.33,36.87A5.32,5.32,0,0,0,6,37.61a1,1,0,0,0-.33.72q0,9.64,0,19.29a.87.87,0,0,0,.23.63,5.63,5.63,0,0,0,3.56.84A41.9,41.9,0,0,1,9.33,36.87Zm-6.92,11V58.18c0,.53,0,1.06,0,1.59a1,1,0,0,0,1,1.08A1,1,0,0,0,4.64,60a2.43,2.43,0,0,0,.09-.71V36.59c0-1-.45-1.52-1.16-1.54s-1.16.53-1.16,1.5Zm93.53,0V45.74q0-4.74,0-9.48a1.14,1.14,0,1,0-2.28-.18,4.34,4.34,0,0,0,0,.72V59.08a4.06,4.06,0,0,0,.06.86,1.11,1.11,0,0,0,1.1.89c.69.05,1.15-.5,1.15-1.35C95.94,55.62,95.93,51.76,95.94,47.91ZM49.18,1.12H37.75a2,2,0,0,0-.84.14,1,1,0,0,0-.59,1.33c.19.7.77.85,1.42.85H60.6a2.24,2.24,0,0,0,.58-.05A1.17,1.17,0,0,0,62,2.13a1.18,1.18,0,0,0-1.28-1Zm0,93.65H60.68c.89,0,1.38-.4,1.4-1.11s-.49-1.21-1.39-1.21H37.53a1.21,1.21,0,0,0-1.24,1.16,1.2,1.2,0,0,0,1.3,1.15Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              class="cls-1"
              d="M48.86,88.21A40.37,40.37,0,1,1,89.13,47.48,40.4,40.4,0,0,1,48.86,88.21Zm7.84-9.64a7.52,7.52,0,1,0-7.5,7.49A7.51,7.51,0,0,0,56.7,78.57ZM18.65,40.46a7.51,7.51,0,1,0,7.49,7.42A7.51,7.51,0,0,0,18.65,40.46Zm30.53-15.6a7.52,7.52,0,1,0-7.53-7.45A7.53,7.53,0,0,0,49.18,24.86ZM79.7,55.43A7.52,7.52,0,1,0,72.21,48,7.49,7.49,0,0,0,79.7,55.43ZM59,70.07a2.83,2.83,0,1,0,2.9-2.79A2.82,2.82,0,0,0,59,70.07ZM27,63.48a2.89,2.89,0,0,0,2.88-2.9A2.84,2.84,0,0,0,27,57.77a2.87,2.87,0,0,0-2.86,2.84A2.92,2.92,0,0,0,27,63.48Zm6.7-37.75a2.84,2.84,0,1,0,2.86-2.84A2.84,2.84,0,0,0,33.68,25.73Zm37.7,12.39a2.87,2.87,0,0,0,2.82-2.87,2.86,2.86,0,1,0-5.71.08A2.84,2.84,0,0,0,71.38,38.12Zm-31.56-21c0,1.64,0,3.28,0,4.92a1.72,1.72,0,0,0,.25.62,2,2,0,0,0,.22-.59c0-3.33,0-6.65,0-10a1.89,1.89,0,0,0-.25-.64,2.65,2.65,0,0,0-.21.68C39.81,13.79,39.82,15.45,39.82,17.11ZM58.15,84.47h.3c0-.2.08-.39.08-.59q0-5,0-10.05a2,2,0,0,0-.22-.59c-.09.19-.25.38-.25.57q0,5,0,10A4.44,4.44,0,0,0,58.15,84.47ZM75.53,37.3v.3c.21,0,.42.08.63.08h7.73a1.7,1.7,0,0,0,.59-.22,1.71,1.71,0,0,0-.57-.23h-7.8A5.81,5.81,0,0,0,75.53,37.3ZM18.28,58.21c-1.3,0-2.6,0-3.9,0a1.53,1.53,0,0,0-.52.22c.17.08.34.23.51.23h7.87c.19,0,.37-.17.56-.26a1.64,1.64,0,0,0-.55-.19C20.93,58.2,19.6,58.21,18.28,58.21Zm5.66-1V57a2.59,2.59,0,0,0-.54-.11c-3.38,0-6.75,0-10.12,0-.19,0-.37.16-.56.25a1.8,1.8,0,0,0,.55.19H23.39A2.54,2.54,0,0,0,23.94,57.19ZM58.46,22.68c0-.09.1-.13.1-.17q0-5.37,0-10.75c0-.12-.14-.25-.29-.49C58,12.68,58.11,22.36,58.46,22.68ZM74.33,39H85.68C85.29,38.46,74.84,38.44,74.33,39ZM40.07,73.19c-.38.38-.46,10.61-.13,11.26C40.24,84.15,40.37,74.36,40.07,73.19Zm45.6-16.12a75.72,75.72,0,0,0-11.23.09C75,57.53,85.26,57.49,85.67,57.07Zm-73-18.24c1.11.28,10.86.17,11.23-.11C23.35,38.35,13.07,38.41,12.68,38.83ZM38.85,21.6v-9l-.16-.06a1.1,1.1,0,0,0-.22.37C38.24,14.69,38.46,21.28,38.85,21.6Zm21,52.8-.21-.08a1.24,1.24,0,0,0-.17.42q0,4.08,0,8.16c0,.15.13.3.2.45l.18,0Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              class="cls-1"
              d="M88.27,36.78a6.79,6.79,0,0,1,3.94.7,1.18,1.18,0,0,1,.5.83q0,9.61,0,19.25a1.15,1.15,0,0,1-.5.81,6.56,6.56,0,0,1-4,.66,41.47,41.47,0,0,0,0-22.25Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              class="cls-1"
              d="M60.3,87.21a6.4,6.4,0,0,1-.71,3.87,1.07,1.07,0,0,1-.77.45l-19.23,0a.84.84,0,0,1-.84-.51,7,7,0,0,1-.69-3.63A41.57,41.57,0,0,0,60.3,87.21Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              class="cls-1"
              d="M38,8.26a5.74,5.74,0,0,1,.7-3.42,1.07,1.07,0,0,1,.75-.48q9.66,0,19.31,0a1.12,1.12,0,0,1,.77.47,6.64,6.64,0,0,1,.74,3.61A42.24,42.24,0,0,0,49.15,6.82,41.18,41.18,0,0,0,38,8.26Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              class="cls-1"
              d="M9.33,36.87a41.9,41.9,0,0,0,.09,22.22,5.63,5.63,0,0,1-3.56-.84.87.87,0,0,1-.23-.63q0-9.65,0-19.29A1,1,0,0,1,6,37.61,5.32,5.32,0,0,1,9.33,36.87Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              class="cls-1"
              d="M2.41,47.91V36.55c0-1,.43-1.53,1.16-1.5s1.16.59,1.16,1.54V59.3a2.43,2.43,0,0,1-.09.71,1,1,0,0,1-1.25.84,1,1,0,0,1-1-1.08c0-.53,0-1.06,0-1.59Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              class="cls-1"
              d="M95.94,47.91c0,3.85,0,7.71,0,11.57,0,.85-.46,1.4-1.15,1.35a1.11,1.11,0,0,1-1.1-.89,4.06,4.06,0,0,1-.06-.86V36.8a4.34,4.34,0,0,1,0-.72,1.14,1.14,0,1,1,2.28.18q0,4.74,0,9.48Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              class="cls-1"
              d="M49.18,1.12H60.76a1.18,1.18,0,0,1,1.28,1,1.17,1.17,0,0,1-.86,1.25,2.24,2.24,0,0,1-.58.05H37.74c-.65,0-1.23-.15-1.42-.85a1,1,0,0,1,.59-1.33,2,2,0,0,1,.84-.14Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              class="cls-1"
              d="M49.17,94.77H37.59a1.2,1.2,0,0,1-1.3-1.15,1.21,1.21,0,0,1,1.24-1.16H60.69c.9,0,1.41.47,1.39,1.21s-.51,1.11-1.4,1.11Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              d="M56.7,78.57A7.52,7.52,0,1,1,49.26,71,7.52,7.52,0,0,1,56.7,78.57Zm-7.51-7.08a7,7,0,1,0,7.05,7A7.05,7.05,0,0,0,49.19,71.49Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              d="M18.65,40.46a7.51,7.51,0,1,1-7.54,7.38A7.5,7.5,0,0,1,18.65,40.46Zm0,14.54a7,7,0,1,0-7-7A7.06,7.06,0,0,0,18.63,55Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              d="M49.18,24.86a7.52,7.52,0,0,1-.12-15,7.52,7.52,0,1,1,.12,15Zm7-7.45a7,7,0,1,0-7.06,7A7,7,0,0,0,56.17,17.41Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              d="M79.7,55.43a7.52,7.52,0,1,1,7.54-7.51A7.52,7.52,0,0,1,79.7,55.43Zm0-14.54A7,7,0,1,0,79.82,55a7,7,0,0,0-.14-14.07Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              d="M59,70.07A2.83,2.83,0,1,1,61.76,73,2.83,2.83,0,0,1,59,70.07Zm.44,0a2.39,2.39,0,1,0,2.35-2.35A2.38,2.38,0,0,0,59.44,70.1Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              d="M27,63.48a2.92,2.92,0,0,1-2.84-2.87A2.87,2.87,0,0,1,27,57.77a2.84,2.84,0,0,1,2.86,2.81A2.89,2.89,0,0,1,27,63.48Zm2.4-2.89A2.34,2.34,0,0,0,27,58.23a2.4,2.4,0,0,0-2.38,2.33A2.45,2.45,0,0,0,27,63,2.38,2.38,0,0,0,29.38,60.59Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              d="M33.68,25.73a2.84,2.84,0,1,1,2.82,2.88A2.85,2.85,0,0,1,33.68,25.73Zm5.22.07a2.35,2.35,0,0,0-2.41-2.43A2.39,2.39,0,1,0,38.9,25.8Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              d="M71.38,38.12a2.84,2.84,0,0,1-2.89-2.79,2.86,2.86,0,1,1,2.89,2.79ZM69,35.27a2.35,2.35,0,0,0,2.37,2.39,2.4,2.4,0,0,0,2.4-2.38,2.44,2.44,0,0,0-2.4-2.41A2.38,2.38,0,0,0,69,35.27Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              d="M39.82,17.11c0-1.66,0-3.32,0-5a2.65,2.65,0,0,1,.21-.68,1.89,1.89,0,0,1,.25.64c0,3.33,0,6.65,0,10a2,2,0,0,1-.22.59,1.72,1.72,0,0,1-.25-.62C39.81,20.39,39.82,18.75,39.82,17.11Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              d="M58.15,84.47a4.44,4.44,0,0,1-.1-.62q0-5,0-10c0-.19.16-.38.25-.57a2,2,0,0,1,.22.59q0,5,0,10.05c0,.2-.06.39-.08.59Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              d="M75.53,37.3a5.81,5.81,0,0,1,.58-.09h7.8a1.71,1.71,0,0,1,.57.23,1.7,1.7,0,0,1-.59.22H76.16c-.21,0-.42-.06-.63-.08Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              d="M18.28,58.21c1.32,0,2.65,0,4,0a1.64,1.64,0,0,1,.55.19c-.19.09-.37.26-.56.26H14.37c-.17,0-.34-.15-.51-.23a1.53,1.53,0,0,1,.52-.22C15.68,58.2,17,58.21,18.28,58.21Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              d="M23.94,57.19a2.54,2.54,0,0,1-.55.1H13.27a1.8,1.8,0,0,1-.55-.19c.19-.09.37-.25.56-.25,3.37,0,6.74,0,10.12,0a2.59,2.59,0,0,1,.54.11Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              d="M58.46,22.68c-.35-.32-.5-10-.17-11.41.15.24.29.37.29.49q0,5.39,0,10.75S58.51,22.59,58.46,22.68Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              d="M74.33,39c.51-.53,11-.51,11.35,0Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              d="M40.07,73.19c.3,1.17.17,11-.13,11.26C39.61,83.8,39.69,73.57,40.07,73.19Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              d="M85.67,57.07c-.41.42-10.71.46-11.23.09A75.72,75.72,0,0,1,85.67,57.07Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              d="M12.68,38.83c.39-.42,10.67-.48,11.23-.11C23.54,39,13.79,39.11,12.68,38.83Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              d="M38.85,21.6c-.39-.32-.61-6.91-.38-8.7a1.1,1.1,0,0,1,.22-.37l.16.06Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              d="M59.83,74.4v8.9l-.18,0c-.07-.15-.2-.3-.2-.45q0-4.08,0-8.16a1.24,1.24,0,0,1,.17-.42Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              class="cls-1"
              d="M49.19,71.49a7,7,0,1,1-7,7A7.09,7.09,0,0,1,49.19,71.49Zm6.13,7a2.67,2.67,0,0,0-.32-.43l-5.35-5.37a.51.51,0,0,0-.85,0Q46.16,75.37,43.49,78c-.33.32-.33.57,0,.9q2.67,2.64,5.31,5.32c.34.34.57.3.89,0C51.43,82.45,53.19,80.7,55,79,55.08,78.81,55.18,78.66,55.32,78.49Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              class="cls-1"
              d="M18.63,55a7,7,0,1,1,7-7A7,7,0,0,1,18.63,55Zm6.14-7c-.13-.16-.23-.32-.36-.45-1.75-1.76-3.51-3.51-5.25-5.28-.36-.37-.61-.34-.95,0C16.48,44,14.75,45.76,13,47.49c-.38.37-.41.63,0,1q2.63,2.58,5.21,5.21c.34.35.58.41.95,0,1.76-1.79,3.54-3.56,5.31-5.34A4.81,4.81,0,0,0,24.77,48Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              class="cls-1"
              d="M56.17,17.41a7,7,0,1,1-7-7.11A7,7,0,0,1,56.17,17.41Zm-7,6.09a2.8,2.8,0,0,0,.43-.34l5.32-5.31a.51.51,0,0,0,0-.85c-1.8-1.78-3.58-3.57-5.36-5.37-.31-.31-.54-.3-.84,0Q46.05,14.31,43.38,17c-.33.32-.37.56,0,.89,1.78,1.76,3.54,3.54,5.31,5.31A4.22,4.22,0,0,0,49.13,23.5Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              class="cls-1"
              d="M79.68,40.89a7,7,0,1,1-7,7.07A7.07,7.07,0,0,1,79.68,40.89Zm6.07,7c-.16-.19-.28-.37-.42-.51-1.72-1.73-3.45-3.44-5.16-5.18-.37-.38-.62-.4-1,0Q76.59,44.8,74,47.39c-.38.37-.38.63,0,1q2.63,2.58,5.21,5.21c.35.35.59.4,1,0,1.74-1.77,3.51-3.52,5.26-5.28A5.86,5.86,0,0,0,85.75,47.87Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              class="cls-1"
              d="M59.44,70.1a2.39,2.39,0,1,1,2.35,2.42A2.39,2.39,0,0,1,59.44,70.1Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              class="cls-1"
              d="M29.38,60.59A2.38,2.38,0,0,1,27,63a2.45,2.45,0,0,1-2.42-2.46A2.4,2.4,0,0,1,27,58.23,2.34,2.34,0,0,1,29.38,60.59Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              class="cls-1"
              d="M38.9,25.8a2.38,2.38,0,0,1-2.35,2.34,2.39,2.39,0,1,1-.06-4.77A2.35,2.35,0,0,1,38.9,25.8Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              class="cls-1"
              d="M69,35.27a2.38,2.38,0,0,1,2.37-2.4,2.44,2.44,0,0,1,2.4,2.41,2.4,2.4,0,0,1-2.4,2.38A2.35,2.35,0,0,1,69,35.27Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              d="M55.32,78.49c-.14.17-.24.32-.37.46-1.76,1.75-3.52,3.5-5.26,5.27-.32.32-.55.36-.89,0q-2.64-2.68-5.31-5.32c-.33-.33-.33-.58,0-.9q2.67-2.65,5.31-5.32a.51.51,0,0,1,.85,0L55,78.06A2.67,2.67,0,0,1,55.32,78.49Zm-6.09-5.34-5.41,5.33,5.4,5.39,5.41-5.36Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              d="M24.77,48a4.81,4.81,0,0,1-.32.43C22.68,50.2,20.9,52,19.14,53.76c-.37.37-.61.31-.95,0Q15.61,51.1,13,48.51c-.39-.39-.36-.65,0-1,1.75-1.73,3.48-3.47,5.21-5.22.34-.35.59-.38.95,0,1.74,1.77,3.5,3.52,5.25,5.28C24.54,47.67,24.64,47.83,24.77,48Zm-6.18,5.33L24,48l-5.29-5.27L13.36,48.1Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              d="M49.13,23.5a4.22,4.22,0,0,1-.46-.34c-1.77-1.77-3.53-3.55-5.31-5.31-.35-.33-.31-.57,0-.89q2.67-2.66,5.31-5.32c.3-.31.53-.32.84,0,1.78,1.8,3.56,3.59,5.36,5.37a.51.51,0,0,1,0,.85l-5.32,5.31A2.8,2.8,0,0,1,49.13,23.5Zm0-.76,5.37-5.36L49.13,12l-5.39,5.37Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              d="M85.75,47.87a5.86,5.86,0,0,1-.37.48c-1.75,1.76-3.52,3.51-5.26,5.28-.36.38-.6.33-1,0Q76.59,51,74,48.4c-.38-.38-.38-.64,0-1q2.63-2.6,5.21-5.22c.38-.39.63-.37,1,0,1.71,1.74,3.44,3.45,5.16,5.18C85.47,47.5,85.59,47.68,85.75,47.87Zm-11.5,0,5.36,5.34c1.78-1.76,3.6-3.57,5.39-5.33l-5.37-5.39Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              class="cls-1"
              d="M49.23,73.15l5.4,5.36-5.41,5.36-5.4-5.39Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              class="cls-1"
              d="M18.59,53.32,13.36,48.1l5.37-5.35L24,48Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              class="cls-1"
              d="M49.11,22.74l-5.37-5.35L49.13,12l5.35,5.36Z"
              transform="translate(-1.52 -0.23)"
            />
            <path
              class="cls-1"
              d="M74.25,47.85l5.38-5.38L85,47.86c-1.79,1.76-3.61,3.57-5.39,5.33Z"
              transform="translate(-1.52 -0.23)"
            />
          </g>
        </g>
      ),
      transform: {
        width: -WIDTH / 2,
        depth: -DEPTH / 2,
      },
    };
  },

  render3D: function (element, layer, scene) {},
};
